import { Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import DocumentListingBase from 'components/Sections/DocumentListingBase';

const AutomaticDocumentListings = ({ fields }): JSX.Element => (
  <section>
    <div className="container">
      {fields.title && <Text tag="h3" field={fields.title} className="mb-3" />}
      <DocumentListingBase editionId={fields.editionId && fields.editionId.value} />
    </div>
  </section>
);

export default withDatasourceCheck()(AutomaticDocumentListings);
